import React from "react";
import Rules from "../../../../../config/rules"
import AbstractTextInput from "./AbstractTextInput";


class LastnameInput extends AbstractTextInput
{
    label = "Nom d'usage*"

    validators = !this.props.isOptional ? ['required', Rules.reg('name')] : [Rules.reg('name')]

    errorMessages = !this.props.isOptional ? [Rules.txtRequis, Rules.txtInvalidChar] : [Rules.txtInvalidChar]

    specs = {
        textTransform: 'uppercase'
    }
}

export default LastnameInput;